var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventsIconTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#002C56",
    strokeLinecap: "square",
    strokeWidth: 1.667,
    d: "M3.333 2.778H30M3.333 7.222H30M3.333 11.667H30M3.333 16.111H30M2.222 20.556H30M2.222 25H30M2.222 29.444H30"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0H18.889V18.889H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002C56",
    fillRule: "nonzero",
    d: "M14.924 16.026V6.218H2.854v9.808h12.07zm0-14.274c.47 0 .878.178 1.224.534.346.356.519.777.519 1.261v12.479c0 .484-.173.897-.519 1.239-.346.342-.753.513-1.224.513H2.854c-.485 0-.896-.171-1.235-.513-.339-.342-.508-.755-.508-1.24V3.548c0-.484.17-.905.508-1.26.339-.357.75-.535 1.234-.535h.85V0h1.743v1.752h6.886V0h1.742v1.752h.85zm-1.7 6.26v1.753H11.48V8.013h1.743zm-3.485 0v1.753h-1.7V8.013h1.7zm-3.443 0v1.753H4.554V8.013h1.742z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIconTfi);
export default __webpack_public_path__ + "static/media/events_icon_tfi.58733a05029852cdb2ec619b89d04023.svg";
export { ForwardRef as ReactComponent };